import { useTranslation } from 'react-i18next';
import { MinimalLayout } from '../components/templates/MinimalLayout.js';
import { Typography } from '../components/atoms/Typography.js';
import { Card } from '../components/atoms/Card.js';

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <MinimalLayout>
      <Card padding="lg" className="text-center">
        <Typography variant="h2" className="mb-2">
          {t('page.not_found_title')}
        </Typography>
        <Typography variant="body">{t('page.not_found_description')}</Typography>
      </Card>
    </MinimalLayout>
  );
}
